import React, {useRef} from "react";
import BaseFunc from "../../base/baseFunctions";
import DateFormat from "./dateFormat";
import PopUp from "../../base/popup";
import ResetPopup from "./resetPopup";
import ResetConfirmationPopup from "./resetConfirmationPopup";

export default function AptitudeResult(props) {


    const resetPopupRef = useRef(null);
    const confirmationResetPopupRef = useRef(null);

    const afterResetTest = () => {
        resetPopupRef.current.open()
    };

    const reset = () => {
        confirmationResetPopupRef.current.close();
        props.reset(props.testId, afterResetTest);

    };

    if(props.temp || !props.isAvailable) {
        return (
            <div className={props.parentClass}>
                <div className="user__box for-empty-aptitude">
                    <div className="grid-x user__test">
                        <div className="small-9 cell"><h3 className="user__test-title">{props.name}</h3></div>
                        <div className="small-3 cell flex-end"><span className="small-icon minus-icon--red"/></div>
                    </div>
                    <div className="user__incomplete">
                        <h3>{props.isAvailable ? 'Test incomplete' : 'Access required'}</h3>
                    </div>
                </div>
            </div>
        )
    }

    const result = props.result || {raw_score: 0, correct_answers: 0,incorrect_answers: 0, unanswered: 0, percentile:0,
        sten:0, t_score: 0, time: 0, time_left: 0, avg_question_time: 0};

    return (
        <div className={props.parentClass}>
            <div className="user__box  for-aptitude ">
                <div className="grid-x user__test">
                    <div className="small-9 cell"><h3 className="user__test-title">{props.name}</h3></div>
                    <div className="small-3 cell flex-end"><span className={`small-icon ${props.finished ? 'tick-icon' : 'minus-icon--red'}`}/></div>
                </div>
                <p className={`user__box__results ${!props.finished ? 'user__box__results--disable' : ''}`}><span className="user__box__desc">Percentile</span><span
                    className="user__box__value flex-end">{result.percentile}%</span></p>
                <p className={`user__box__results ${!props.finished ? 'user__box__results--disable' : ''}`}><span className="user__box__desc">STEN Score</span><span
                    className="user__box__value flex-end">{result.sten}</span></p>
                <p className={`user__box__results ${!props.finished ? 'user__box__results--disable' : ''}`}><span className="user__box__desc">T Score</span><span
                className="user__box__value flex-end">{result.t_score}</span></p>
                <p className={`user__box__results ${!props.finished ? 'user__box__results--disable' : ''}`}><span className="user__box__desc">Raw Score</span><span
                    className="user__box__value flex-end">{result.raw_score}%</span></p>
                <br/>
                <p className={`user__box__results ${!props.finished ? 'user__box__results--disable' : ''}`}><span className="user__box__desc">Correct answers</span><span
                    className="user__box__value flex-end">{result.correct_answers}</span></p>
                <p className={`user__box__results ${!props.finished ? 'user__box__results--disable' : ''}`}><span className="user__box__desc">Inorrect answers</span><span
                    className="user__box__value flex-end">{result.incorrect_answers}</span></p>
                <p className={`user__box__results ${!props.finished ? 'user__box__results--disable' : ''}`}><span className="user__box__desc">Unanswered</span><span
                    className="user__box__value flex-end">{result.unanswered}</span></p>
                <br/>
                <p className={`user__box__results ${!props.finished ? 'user__box__results--disable' : ''}`}><span className="user__box__desc">Time used</span><span
                    className="user__box__value flex-end">{BaseFunc.millisToMinutesAndSeconds(result.time)}</span></p>
                <p className={`user__box__results ${!props.finished ? 'user__box__results--disable' : ''}`}><span className="user__box__desc">Time left</span><span
                    className="user__box__value flex-end">{BaseFunc.millisToMinutesAndSeconds(result.time_left)}</span></p>
                <p className={`user__box__results ${!props.finished ? 'user__box__results--disable' : ''}`}><span
                    className="user__box__desc">Average time per question</span><span
                    className="user__box__value flex-end">{BaseFunc.millisToMinutesAndSeconds(result.avg_question_time)}</span></p>
                {!props.finished ? <div style={{height: "40px", marginTop: "20px"}}/>  :
                    <div className="grid-x align-middle mar-top-20">
                        <div className="cell"><p className="user__box__date">Date taken:
                            {DateFormat.format(props.finished_at)}</p></div>
                        <div className="cell shrink">
                            <a className={'button button--white'} href={`/group/tests/${props.testCode}/download/${props.userId}`} target={'_blank'}><span className="button__hovered"/>Report</a>
                        </div>
                        <div className="cell auto flex-end">
                            <button className="button button--white" onClick={() => confirmationResetPopupRef.current.open()}><span className="button__hovered"/>Reset
                                test
                            </button>
                        </div>
                    </div>
                }
                <PopUp ref={resetPopupRef}>
                    <ResetPopup retakes={props.retakes} name={props.name} />
                </PopUp>
                <PopUp ref={confirmationResetPopupRef}>
                    <ResetConfirmationPopup onCancel={() => {confirmationResetPopupRef.current.close()}} onConfirm={reset}/>
                </PopUp>
            </div>

        </div>
    )
}